import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import {
  Container, Box, TextField, Button,
  Typography, Alert, Paper
} from '@mui/material';

const API = process.env.REACT_APP_API_URL;

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, subdominio } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await axios.post(`${API}/api/usuarios/login`, {
        email,
        password,
        subdominio: subdominio || null
      });
      login(res.data);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Email o contraseña incorrectos');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 10 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" align="center" gutterBottom>
            Smart Track
          </Typography>
          <Typography variant="h6" align="center" color="text.secondary" gutterBottom>
            Iniciar Sesión
          </Typography>
          {subdominio && (
            <Typography variant="body2" align="center" color="primary" sx={{ mb: 2 }}>
              {subdominio}.geo-energy-tech.com
            </Typography>
          )}
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <TextField
            fullWidth label="Email" type="email"
            value={email} onChange={e => setEmail(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth label="Contraseña" type="password"
            value={password} onChange={e => setPassword(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Button
            fullWidth variant="contained"
            size="large" onClick={handleLogin}
          >
            Ingresar
          </Button>
        </Paper>
      </Box>
    </Container>
  );
}